var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExponential(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0159 14.0159V25.1905H21.127C23.3712 25.1905 25.1905 23.3712 25.1905 21.127V14.0159H14.0159ZM21.8042 22.1429H16.3862V20.1111H21.8042V22.1429ZM21.8042 18.0794H16.3862V16.0476H21.8042V18.0794Z",
    fill: "#25AA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.873 0.80957C2.62881 0.80957 0.809524 2.62886 0.809524 4.87305V11.9841H11.9841V0.80957H4.873ZM9.77814 8.085H7.92067V9.94243H5.8889V8.085H4.03148V6.05324H5.8889V4.19581H7.92067V6.05324H9.77814V8.085Z",
    fill: "#25AA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.809524 14.0159V21.127C0.809524 23.3712 2.62881 25.1905 4.873 25.1905H11.9841V14.0159H0.809524ZM9.65481 20.4087L8.21814 21.8454L6.90476 20.5319L5.59129 21.8454L4.15462 20.4087L5.46809 19.0952L4.15471 17.7818L5.59138 16.3451L6.90476 17.6586L8.21824 16.3452L9.6549 17.7819L8.34143 19.0952L9.65481 20.4087Z",
    fill: "#25AA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.127 0.80957H14.0159V11.9842H25.1905V4.87305C25.1905 2.62886 23.3712 0.80957 21.127 0.80957ZM21.8042 7.92067H16.3862V5.8889H21.8042V7.92067Z",
    fill: "#25AA4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.381,
    height: 24.381,
    fill: "white",
    transform: "translate(0.809524 0.80957)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExponential);
export default __webpack_public_path__ + "static/media/exponential.5c158a5b8ded1ae5e6a0c1ae23ba4895.svg";
export { ForwardRef as ReactComponent };